import { RekensprintThemeColors } from './rekensprint-theme.colors';
import { createThemePreset } from 'projects/shared/src/lib/style/configuration/theme-color.facrory';

export const RekensprintPreset = createThemePreset(RekensprintThemeColors);
